module.exports = __webpack_public_path__ + "img/XiaomiSmartTV.f5c86a2e.png";